import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { MFA_REQUIRED_CODE, hasMessageCode } from 'pages/mfa/models';

type HeldRequest = {
  error: AxiosError;
  resolve: (response: AxiosResponse) => void;
  reject: (reason: unknown) => void;
};

type GateListener = (open: boolean) => void;

const held: HeldRequest[] = [];
const listeners = new Set<GateListener>();

const notify = (open: boolean) =>
  listeners.forEach((listener) => listener(open));

export const isMfaRequiredError = (error: AxiosError): boolean => {
  const response = error?.response;
  if (!response || response.status !== 403) return false;
  return hasMessageCode((response.data as any)?.errors, MFA_REQUIRED_CODE);
};

export const holdForMfa = (error: AxiosError): Promise<AxiosResponse> =>
  new Promise((resolve, reject) => {
    held.push({ error, resolve, reject });
    if (held.length === 1) notify(true);
  });

export const replayHeldRequests = (
  retry: (config: AxiosRequestConfig) => Promise<AxiosResponse>
) => {
  const items = held.splice(0);
  notify(false);
  items.forEach((item) =>
    retry(item.error.config).then(item.resolve, item.reject)
  );
};

export const rejectHeldRequests = () => {
  const items = held.splice(0);
  notify(false);
  items.forEach((item) => item.reject(item.error));
};

export const subscribeToMfaGate = (listener: GateListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
